import Vue from 'vue'

const context = require.context('../../components/common', true, /index\.js$/);
context.keys().forEach(key => {
  try {
    // console.info('auto import', key);
    Vue.use(context(key).default)
  } catch (e) {
    throw new Error('import ui componets is fail' + e)
  }
});
